import React from 'react';

const Map = ({text, lat, long}) => {
    return (
        <div className="row">
            <div className="col-lg-10 col-12">
                <div id="contact-map">
                    <iframe
                        src={`https://maps.google.com/maps?q=${lat},${long}&hl=en&z=10&output=embed`}
                        title={'Contact Map'}
                        style={{width: '100%', height: '100%', border: 0}}
                    />
                </div>
            </div>
        </div>
    );
};

export default Map;